/* efp2 — 購物車顯示已選選項（由 shirt-customiser.js 抽出，2026-10-21）
   為咗令購物車選項喺「所有頁面」都顯示，但定製器本身只喺產品頁載入。
   呢個檔案可以 global 載入（defer）；重複載入有 guard 保護。 */
(function () {
  if (window.__efp2CartProps) return;
  window.__efp2CartProps = true;

/* ============================================================
     ② 購物車顯示已選選項（Blockshop 唔會顯示 line item properties）
     ============================================================ */
  (function initCartDisplay() {
    var STYLE_ID = 'sc-cart-style';
    var CSS = '' +
      '.sc-cart-props{margin:6px 0 2px;display:flex;flex-direction:column;gap:2px;}' +
      '.sc-cart-prop{display:flex;gap:6px;font-size:12px;line-height:1.35;opacity:.85;}' +
      '.sc-cart-prop-k{min-width:104px;flex:0 0 auto;text-transform:uppercase;letter-spacing:.04em;opacity:.75;}' +
      '.sc-cart-prop-v{flex:1 1 auto;}';

    function injectStyle() {
      if (document.getElementById(STYLE_ID)) return;
      var s = document.createElement('style');
      s.id = STYLE_ID; s.textContent = CSS;
      (document.head || document.documentElement).appendChild(s);
    }
    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
      });
    }
    var CACHE_KEY = 'sc_cart_snapshot_v1';
    function readCache() {
      try { var s = localStorage.getItem(CACHE_KEY); return s ? JSON.parse(s) : null; } catch (e) { return null; }
    }
    function saveCache(c) {
      try {
        localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), items: (c.items || []).map(function (it) {
          return { id: it.id, variant_id: it.variant_id, properties: it.properties || {} };
        }) }));
      } catch (e) {}
    }
    function paint(cart) {
      var nodes = document.querySelectorAll('.cart--item');
      if (!nodes.length || !cart || !cart.items || !cart.items.length) return 0;
      var byLine = {}, byVariant = {};
      cart.items.forEach(function (it, i) {
        byLine[i + 1] = it;
        (byVariant[it.variant_id] = byVariant[it.variant_id] || []).push(it);
      });
      var touched = 0;
      Array.prototype.forEach.call(nodes, function (node) {
        var line = parseInt(node.getAttribute('data-line-num'), 10);
        var vid = parseInt(node.getAttribute('data-variant-id'), 10);
        var item = byLine[line];
        if (!item && byVariant[vid] && byVariant[vid].length === 1) item = byVariant[vid][0];
        if (!item || !item.properties) return;
        var keys = Object.keys(item.properties).filter(function (k) {
          return k.charAt(0) !== '_' && item.properties[k];
        });
        var host = node.querySelector('.cart--item--info') || node.querySelector('.cart--item-details') || node;
        var existing = host.querySelector('.sc-cart-props');
        if (!keys.length) { if (existing) existing.remove(); return; }
        var html = keys.map(function (k) {
          return '<div class="sc-cart-prop"><span class="sc-cart-prop-k">' + esc(k) +
            '</span><span class="sc-cart-prop-v">' + esc(item.properties[k]) + '</span></div>';
        }).join('');
        if (existing) {
          if (existing.getAttribute('data-sig') !== html) { existing.innerHTML = html; existing.setAttribute('data-sig', html); }
          return;
        }
        var wrap = document.createElement('div');
        wrap.className = 'sc-cart-props';
        wrap.setAttribute('data-sig', html);
        wrap.innerHTML = html;
        host.appendChild(wrap);
        touched++;
      });
      if (touched) console.log('[SC] cart properties rendered on', touched, 'line(s)');
      return touched;
    }
    /* v2（Ben 2026-10-21）：① 先用上次記住嘅購物車資料即時畫（0 秒見到選項）
       ② add-to-bag 之後即刻再確認，唔死等 250ms debounce
       ③ 失敗自動重試 3 次＋console 留記錄（唔再靜靜失敗） */
    function run() {
      var nodes = document.querySelectorAll('.cart--item');
      if (!nodes.length) return;
      var cached = readCache();
      if (cached && cached.items && cached.items.length === nodes.length) paint(cached);
      var tries = 0;
      (function pull() {
        tries++;
        fetch('/cart.js?_=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
          .then(function (cart) { saveCache(cart); paint(cart); })
          .catch(function (err) {
            if (tries < 3) { setTimeout(pull, 400 * tries); return; }
            if (window.console) console.warn('[SC] cart.js failed after', tries, 'tries:', (err && err.message) || err);
          });
      })();
    }

    function boot() {
      try { injectStyle(); } catch (e) {}
      run();
      var t = null;
      var obs = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          obs.disconnect();
          try { run(); } finally {
            obs.observe(document.body, { childList: true, subtree: true });
          }
        }, 250);
      });
      obs.observe(document.body, { childList: true, subtree: true });
      // 開 drawer / 去 cart 頁時再確認一次
      document.addEventListener('click', function (e) {
        var t2 = e.target;
        if (t2 && t2.closest && t2.closest('[data-drawer-trigger], .cart--toggle, a[href*="/cart"], [data-cart-toggle]')) {
          setTimeout(run, 600); setTimeout(run, 1600);
        }
      }, true);
      window.addEventListener('pageshow', function () { setTimeout(run, 300); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();
})();
